import React, { useEffect } from 'react';
import { RouteConfigComponentProps } from 'react-router-config';
import loadable from '@loadable/component';
import { useIsLoggedIn } from '@cp/entities/currentUser';
import { useRouter } from '@cp/shared/router';
import { useClientWebResolver } from '@cp/entities/clientWebRoutes';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { useClientProfile } from 'src/entities/client';
import { useIsNeedWorkingRulesOnboarding } from 'src/features/workingRulesOnboarding';

const HomeNew1 = loadable(() => import('./new1'));

const HomePage: React.FC<RouteConfigComponentProps> = (props) => {
  const isLoggedIn = useIsLoggedIn();
  const router = useRouter();
  const profile = useClientProfile();
  const pageResolver = useClientWebResolver();
  const isNeedWorkingRulesOnboarding = useIsNeedWorkingRulesOnboarding();

  useEffect(() => {
    // Wait for the profile; onboarding is started by WorkingRulesOnboardingPolicy via intent
    if (!isLoggedIn || !profile || isNeedWorkingRulesOnboarding) return;

    router.navigate(pageResolver.resolve({ page: ClientWebPage.Profile }));
  }, [isLoggedIn, isNeedWorkingRulesOnboarding, pageResolver, profile, router]);

  return <HomeNew1 {...props} />;
};

export default HomePage;
